import { PlusLg } from 'react-bootstrap-icons';
import imagePlaceholder from '../../../assets/img/imagePlaceholder.png';

type HeatIslandImageProps = {
  imageDataURI?: string;
  className?: string;
};

const HeatIslandImage: React.FC<HeatIslandImageProps> = ({ imageDataURI, className }) => {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute z-10 flex h-full w-full items-center justify-center">
        <PlusLg className="relative -left-[1px] flex h-7 w-7 items-center justify-center" />
      </div>
      <img
        className={`w-full bg-placeholderBgColor transition duration-200 ease-out ${
          imageDataURI ? 'opacity-100' : 'opacity-50'
        }`}
        src={imageDataURI ?? imagePlaceholder}
        alt="Mapa de temperaturas en tu zona"
      />
    </div>
  );
};

export default HeatIslandImage;
